<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
};
</script>


<style lang="less">

body {
  overflow: hidden;
  box-sizing: border-box;
  margin: 0;
}

#app {
  position: absolute;
  box-sizing: content-box;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  background-image: url('../src/assets/background-web.jpg');
  background-position: center;
  background-size: cover;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
